module.exports = __webpack_public_path__ + "img/logo_no_text.f7a7a158.png";